/**
 * Collector admin api
 * Collector stats observe and manage
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class ZombieService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param zombieId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public disableZombie(zombieId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public disableZombie(zombieId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public disableZombie(zombieId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public disableZombie(zombieId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (zombieId === null || zombieId === undefined) {
            throw new Error('Required parameter zombieId was null or undefined when calling disableZombie.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('patch',`${this.basePath}/zombies/${encodeURIComponent(String(zombieId))}/disable`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param zombieId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getLoopChart(zombieId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getLoopChart(zombieId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getLoopChart(zombieId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getLoopChart(zombieId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (zombieId === null || zombieId === undefined) {
            throw new Error('Required parameter zombieId was null or undefined when calling getLoopChart.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/zombies/${encodeURIComponent(String(zombieId))}/loop-chart`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param zombieId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRequestsCountChart(zombieId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getRequestsCountChart(zombieId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getRequestsCountChart(zombieId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getRequestsCountChart(zombieId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (zombieId === null || zombieId === undefined) {
            throw new Error('Required parameter zombieId was null or undefined when calling getRequestsCountChart.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/zombies/${encodeURIComponent(String(zombieId))}/request-chart`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param zombieId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRequestsTimeChart(zombieId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getRequestsTimeChart(zombieId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getRequestsTimeChart(zombieId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getRequestsTimeChart(zombieId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (zombieId === null || zombieId === undefined) {
            throw new Error('Required parameter zombieId was null or undefined when calling getRequestsTimeChart.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/zombies/${encodeURIComponent(String(zombieId))}/request-time-chart`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param zombieId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRequestsTypeChart(zombieId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getRequestsTypeChart(zombieId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getRequestsTypeChart(zombieId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getRequestsTypeChart(zombieId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (zombieId === null || zombieId === undefined) {
            throw new Error('Required parameter zombieId was null or undefined when calling getRequestsTypeChart.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/zombies/${encodeURIComponent(String(zombieId))}/request-type-chart`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param zombieId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getZombie(zombieId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public getZombie(zombieId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public getZombie(zombieId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public getZombie(zombieId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (zombieId === null || zombieId === undefined) {
            throw new Error('Required parameter zombieId was null or undefined when calling getZombie.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/zombies/${encodeURIComponent(String(zombieId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param zombieId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public releaseChats(zombieId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public releaseChats(zombieId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public releaseChats(zombieId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public releaseChats(zombieId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (zombieId === null || zombieId === undefined) {
            throw new Error('Required parameter zombieId was null or undefined when calling releaseChats.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('patch',`${this.basePath}/zombies/${encodeURIComponent(String(zombieId))}/release-chats`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
